import { Search, X } from "lucide-react";
import { Input } from "@/components/ui/input.jsx";
import { searchStyles } from "@/lib/status-styles.js";

/**
 * Search input for Needs Mapping and Your Mappings.
 * @param {Object} props
 * @param {string} props.value - Current search value
 * @param {(value: string) => void} props.onChange - Called when the search value changes
 * @param {string} [props.placeholder="Search..."] - Input placeholder / hint text
 * @param {string} [props.testId="input-search-classification"] - Test ID for the input
 * @returns {JSX.Element}
 */
export default function ClassificationSearch({
  value,
  onChange,
  placeholder = "Search...",
  testId = "input-search-classification",
}) {
  return (
    <div className={searchStyles.container}>
      <Input
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={searchStyles.input}
        data-testid={testId}
      />
      {value ? (
        <button
          type='button'
          onClick={() => onChange("")}
          className='absolute right-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground cursor-pointer hover:text-foreground transition-colors z-10'
          data-testid='button-clear-search'
          title='Clear search'>
          <X className='h-4 w-4' />
        </button>
      ) : (
        <Search className={searchStyles.icon} />
      )}
    </div>
  );
}
